import {post} from "@/axios/request";

export const getBusiList = (page, size, data) => {
  return post("/service/api/client/getBusiList", {
    page,
    size,
    ...data
  })
}

export const getBusiInfo = data => {
  return post("/service/api/client/getBusiInfo", data)
}

export const cancelBusi = data => {
  return post("/service/api/client/cancelBusi", data)
}

export const amendOrder = data => {
  return post("/service/api/client/amendOrder", data)
}
